import styled from 'styled-components';

import { ButtonPrimary, H3, LabelRegular } from '@comeon/ui';

export const StyledButtonWrapper = styled.div`
	margin-top: 24px;
`;

export const StyledTitle = styled(H3)`
	text-align: center;
	margin-top: 10px;
`;

export const StyledDescription = styled(LabelRegular)`
	text-align: center;
	margin: 10px 0 30px 0;
`;

export const StyledUserIcon = styled.div`
	margin-left: 43%;
	svg {
		width: 42px;
		height: 42px;
	}
`;

export const StyledButtonPrimary = styled(ButtonPrimary)`
	font: var(--h3);
	margin-bottom: 10px;
	border-radius: 26px;
	> svg {
		height: auto;
		padding-right: 0;
		margin-left: 5px;
		vertical-align: baseline;
	}
`;

export const StyledButtonContent = styled.span`
	font: var(--h3);
	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 7px;
	color: var(--mitid-button-text-color);
`;
